/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Factor_RequiredInputs */

const en_error_factor_required = /** @type {(inputs: Error_Factor_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your role requires a second step: keep at least one.`)
};

/**
* | output |
* | --- |
* | "Your role requires a second step: keep at least one." |
*
* @param {Error_Factor_RequiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_factor_required = /** @type {((inputs?: Error_Factor_RequiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Factor_RequiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_factor_required(inputs)
});